import React from "react";
import "./InfoMessage.scss";
import {strings} from "../../strings/strings";

export const AdditionalCovarageVtplMessage = () => {
    return (
        <div>
            <span className={'info-message-grey'}>{strings.additionalCoverageVtplMessage}</span>
        </div>
    )
};